import { useState } from 'react';
import { createModel } from 'hox';
import { TablePaginationConfig } from 'antd/es/table/interface';
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants';
import { wpbService } from './wpbService';
import { useGlobalModel, transPgToPaginationTotal } from '@/model/globalModel';
import { convertRes2Blob } from '@/utils/exportFile';
import { ISearchPage } from '@/types/AppTypes';
import { IWpbDetail, IWpbSearchFields } from './wpbTypes';
import moment from 'moment';

export const useWpbModel = createModel(function () {
	const {
		user: { shopCode },
		setLoadingInfo,
	} = useGlobalModel(({ user }) => [user]);
	/**
	 * 列表
	 */
	//列表数据源
	const [dataSource, setDataSource] = useState<IWpbDetail[]>([]);
	//查询条件
	const [searchParam, setSearchParam] = useState<IWpbSearchFields>({});
	//分页参数
	const initPgCfg: TablePaginationConfig = {
		pageSize: DEFAULT_PAGE_SIZE,
		current: DEFAULT_FIRST_PAGE_NUM,
	};
	const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
	//表格多选id值
	const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
	const [loading, setLoading] = useState<boolean>(false);

	// 时间装换
	const changeTime = (oldTime: string) => {
		let newDate: number;
		// 当前时间毫秒
		let nowSecond = Date.now();
		// 预计付款时间毫秒
		let oldDate = new Date(oldTime).getTime();
		// 相差时间差
		let difference = Number(nowSecond) - Number(oldDate);
		if (difference <= 0) {
			newDate = 0;
			return newDate;
		}else {
			newDate = Math.floor((Number(nowSecond) - Number(oldDate))/86400000)
			return newDate
		}
	};

	//列表查询
	const loadData = async (
		page: ISearchPage = initPgCfg,
		searchValue: IWpbSearchFields = searchParam
	) => {
		setLoading(true);
		const searchParams = {
			shopCode,
			...searchValue,
			pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
			pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
		};
		let { retData } = await wpbService.page(searchParams);
		//debugger
		const { records, ...pg } = retData;
		console.log('records',records)
		const newData = records.map((item) => {
			return {
				...item,
				waitAmount: Number(item.amountTotal) - Number(item.countPrice),
				// currencyName: '人民币',
				estimatedTime: item.estimatedTime ? moment(item.estimatedTime).format("YYYY-MM-DD HH:mm:ss") : '',
				payTime: item.payTime ? moment(item.payTime).format("YYYY-MM-DD HH:mm:ss") : '',
				// dataNum: item.estimatedTime ? changeTime(item.estimatedTime as string) : 0
				dataNum: item.warningType === "warning.overdue" ? item.estimatedTime ? changeTime(item.estimatedTime as string) : 0 : 0,
			};
		}).sort((a,b)=>{
			return b.waitAmount-a.waitAmount
		})
		console.log(newData)
		setPgCfg(transPgToPaginationTotal(pg));
		setDataSource(newData);
		setLoading(false);
	};
	//设置搜索value
	const updateSearchParam = (updateParam: IWpbSearchFields) => {
		setSearchParam({ ...searchParam, ...updateParam });
	};

	//重置搜索参数
	const resetSearchParam = () => {
		setSearchParam({});
		setSelectedRowKeys([]);
		loadData(initPgCfg, {});
	};

	//导出
	const exportWpb = async (searchValue: IWpbSearchFields = searchParam) => {
		setLoadingInfo({ loadingVisible: true, txt: '快速导出中' });
		try {
			const searchParams = {
				shopCode,
				...searchValue,
				singleCode: selectedRowKeys?.join(),
				pageSize: -1,
				pageNum: 1,
			};

			let result = await wpbService.export(searchParams);
			result && setLoadingInfo({ loadingVisible: false, txt: '' });
			convertRes2Blob(result);
		} catch {
			setLoadingInfo({ loadingVisible: false, txt: '' });
		}
	};

	return {
		/***field***/
		searchParam,
		dataSource,
		selectedRowKeys,
		pgCfg,
		loading,
		/***method***/
		setDataSource,
		setSelectedRowKeys,
		resetSearchParam,
		updateSearchParam,
		loadData,
		exportWpb,
	};
});
